export const REQUEST_SET_EXERCISE_ORDER_NAME = 'exercise/REQUEST_SET_EXERCISE_ORDER_NAME';
export const REQUEST_ADD_EXERCISE_TO_WORKOUT = 'exercise/REQUEST_ADD_EXERCISE_TO_WORKOUT';
export const REQUEST_ADD_ALTERNATIVE_EXERCISE = 'exercise/REQUEST_ADD_ALTERNATIVE_EXERCISE';
export const REQUEST_SET_ALTERNATIVE_EXERCISE = 'exercise/REQUEST_SET_ALTERNATIVE_EXERCISE';
export const REQUEST_REPLACE_EXERCISE_IN_WORKOUT = 'exercise/REQUEST_REPLACE_EXERCISE_IN_WORKOUT';

export const REQUEST_SAVE_EXERCISE_PROPERTY = 'exercise/REQUEST_SAVE_EXERCISE_PROPERTY';
export const REQUEST_SAVE_DIE_ROLL_OPTIONS = 'exercise/REQUEST_SAVE_DIE_ROLL_OPTIONS';
export const REQUEST_ASSIGN_PROPERTIES = 'exercise/REQUEST_ASSIGN_PROPERTIES';
export const REQUEST_UNASSIGN_FROM_CLIENT = 'exercise/REQUEST_UNASSIGN_FROM_CLIENT';
